import { AxiosInstance } from 'axios';
import { QuickMenuService } from 'services';

export interface QuickMenuServiceModel {
  create: ReturnType<typeof QuickMenuService.create>;
  remove: ReturnType<typeof QuickMenuService.remove>;
  update: ReturnType<typeof QuickMenuService.update>;
}

export const initQuickMenuService = (axios: AxiosInstance): QuickMenuServiceModel => ({
  create: QuickMenuService.create(axios),
  update: QuickMenuService.update(axios),
  remove: QuickMenuService.remove(axios),
});
